import { useMutation } from '@tanstack/react-query';

import * as Filtrator from '@Stores/Filtrator';
import * as PageProductStore from '@Stores/PageProduct';
import Configurator from '@Api/Configurator';
import { useRequest } from '@Contexts/Request';

import type { ProductData } from '@Types/Product';
import type { ParamsData } from '@Api/Configurator/getFilterResult';

const useChangeFilters = (id: ProductData['id']) => {
  const entityId = 'configurator-textile';
  const selected = Filtrator.useSelected(entityId);
  const { region } = useRequest();
  const {
    product: { modelId },
  } = PageProductStore.useData();
  const keys = ['selected-filters', modelId, region];

  const { mutateAsync, isPending } = useMutation({
    mutationKey: keys,
    mutationFn: async () => {
      const params: ParamsData = {};

      Object.keys(selected.parameters).map((parameter) => {
        if (parameter === 'price') {
          return (params[parameter] = {
            min: +selected.parameters[parameter].default[0],
            max: +selected.parameters[parameter].default[1],
          });
        }
        return (params[parameter] = selected.parameters[parameter].default);
      });

      const res = await Configurator.getFilterResultCount({
        shopProductId: id,
        params,
      });
      return res;
    },
    onSuccess: (res) => {
      Filtrator.changeCount(entityId, { ...res.fabricFilters, totalCount: res.count });
    },
  });

  return {
    changeFilters: mutateAsync,
    isPending,
  };
};

export default useChangeFilters;
